import axios from 'axios'

const wp = ({type, data}) => new Promise((resolve, reject) => {
  if (type === 'posts') {
    var url = 'https://wordpress.adop.co/wp-json/wp/v2/posts?'
    if (data.categories) {
      url += 'categories=' + data.categories
    } else {
      data.categories = false
    }
    axios.get(url, {
      params:
        {
          page: data.page ? data.page : 1,
          per_page: data.per_page ? data.per_page : 5,
          order: data.order ? data.order : 'desc',
          orderby: data.orderby ? data.orderby : 'date'
        }
    }).then(function (resp) {
      if (type === 'posts') {
        var news = []
        resp.data.forEach(function (item, i, arr) {
          if (data.categories === 2) {
            item.img = ''
            axios.get('https://wordpress.adop.co/wp-json/wp/v2/media?parent=' + item.id, {}).then(function (iresp) {
              item.img = iresp.data[0].source_url
            })
          }
          news.push(item)
        })
      }
      resolve(news)
    }).catch(function (error) {
      reject(error)
    })
  }

  if (type === 'post') {
    axios.get('https://wordpress.adop.co/wp-json/wp/v2/posts' + '?slug=' + data.slug, {})
      .then(function (resp) {
        var article = {}
        article = {
          title: resp.data[0].title.rendered,
          content: resp.data[0].content.rendered,
          date: resp.data[0].date,
          slug: resp.data[0].slug
        }
        axios.get('https://wordpress.adop.co/wp-json/wp/v2/media?parent=' + resp.data[0].id, {}).then(function (iresp) {
          article.img = iresp.data[0].source_url
        })
        resolve(article)
      }).catch(function (error) {
        reject(error)
      })
  }
})
export default wp



// WEBPACK FOOTER //
// ./src/utils/wp.js